<template>
  <v-layout row class="wrapper overflow-wrapper border__bottom">
    <!-- FIXED CONTAINER -->
    <v-flex
      :style="{ 'min-width': `calc(100% / ${visibleFields.length})` }"
      class="border__left"
      shrink
    >
      <v-layout column>
        <table-header
          shrink
          :items="[headerItems.fixed]"
          :pagination="pagination"
          :prepend-sale-status-column="$router.currentRoute.name === 'tickets'"
          @sort="$emit('sort', $event)"
        >
          <template v-slot:prefix>
            <v-checkbox
              v-model="allSelected"
              :style="hideCheckbox && 'display:none'"
              hide-details
              dense
              class="action_checkbox align-center justify-center"
              background-color="#f5f5f5"
              color="#666666"
              @change="handleSelectAll"
            />
          </template>
        </table-header>
        <!-- :style="{ 'grid-auto-columns': `50px minmax(150px, calc(100% / ${visibleFields.length}))` }" -->
        <div
          v-for="attendee in attendees"
          :key="attendee.id"
          class="table_grid_fixed"
          :style="`
            ${bodyStyle};
            ${isHovering(attendee.id) && `background-color: ${findBackgroundHoverColor(attendee)}`}
          `"
          @click="$emit('click', attendee.id)"
          @mouseover="hoveringRowId = attendee.id"
          @mouseout="hoveringRowId = undefined"
        >
          <div @click.stop>
            <color-toggle-button
              v-if="showToggleButton"
              :label="findToggleLabel(attendee)"
              :type="findToggleType(attendee)"
              :value="isOrderItemActive(attendee)"
              class="toggle-container"
              @changeToggleValue="value => updateToggleSwitch(attendee.id, value)"
            />
            <v-checkbox
              v-else
              :style="hideCheckbox && 'display:none'"
              :value="selectedCopy[attendee.id]"
              hide-details
              dense
              :disabled="attendee.hasOwnProperty('isSoldOut') ? !attendee.isSoldOut : false"
              class="align-center justify-center action_checkbox_fixed"
              @change="updateSelected(attendee.id, $event)"
            />
          </div>
          <div class="list_element">
            <span v-if="headerItems.fixed === 'Status' && attendee.status">
              {{ attendee.status }}
            </span>
            <v-layout v-if="headerItems.fixed === 'Category'" row>
              <v-icon :color="attendee.category.color" size="13" style="padding-right: 6px">
                fiber_manual_record
              </v-icon>
              <span>{{ attendee.category.name }}</span>
            </v-layout>
            <span v-else>
              <span
                v-if="headerItems.fixed === 'Broj mobitela' && attendee.fields[headerItems.fixed]"
                row
              >
                {{ JSON.parse(attendee.fields[headerItems.fixed]).numberPrefix }}
                {{ JSON.parse(attendee.fields[headerItems.fixed]).number }}
              </span>
              <span
                v-if="
                  Object.keys(attendeeFields).length !== 0 &&
                    attendeeFields[headerItems.fixed] &&
                    attendeeFields[headerItems.fixed].type.toLowerCase() === 'country' &&
                    attendee.fields[headerItems.fixed]
                "
                row
              >
                <img
                  style="margin-right: 6px"
                  width="20"
                  height="12"
                  :src="`${frontendURL}/assets/flags/${attendee.fields[
                    headerItems.fixed
                  ].toLowerCase()}.svg`"
                >
                {{ attendee.fields[headerItems.fixed] }}
              </span>
              <span v-else>
                <v-icon
                  v-if="
                    ['tickets', 'promo-codes'].includes($router.currentRoute.name) &&
                      ['discount', 'price'].includes(headerItems.fixed.toLowerCase())
                  "
                  color="red"
                  size="13"
                >fiber_manual_record</v-icon>
                {{ displayAttendeeField(attendee, headerItems.fixed) }}
              </span>
            </span>
          </div>
        </div>
      </v-layout>
    </v-flex>

    <!-- SCROLLABLE CONTAINER -->
    <v-flex ref="scrollableElement" class="wrapper_scrollable border__right" grow>
      <div>
        <table-header
          :items="headerItems.scrollable"
          :pagination="pagination"
          @sort="$emit('sort', $event)"
        />
        <div
          v-for="attendee in attendees"
          :key="attendee.id"
          class="table_grid"
          :style="`
            grid-auto-columns: minmax(170px, calc(100% / ${headerItems.scrollable.length}));
          `"
          @click="$emit('click', attendee.id)"
          @mouseover="hoveringRowId = attendee.id"
          @mouseout="hoveringRowId = undefined"
        >
          <div
            v-for="(eventField, index) in headerItems.scrollable"
            :key="index"
            class="list_element"
            :style="`${
              isHovering(attendee.id) && `background-color: ${findBackgroundHoverColor(attendee)}`
            }`"
          >
            <v-layout v-if="eventField === 'Category'" row>
              <v-icon :color="attendee.category.color" size="13" style="padding-right: 6px">
                fiber_manual_record
              </v-icon>
              <span>{{ attendee.category.name }}</span>
            </v-layout>
            <v-layout v-else-if="eventField === 'Color'" row>
              <v-icon
                :color="attendee.color.hexadecimal"
                size="1.8rem"
                style="padding-right: 0.5rem"
              >
                fiber_manual_record
              </v-icon>
              <span style="margin-top: 2px">{{ attendee.color.name }}</span>
            </v-layout>
            <v-layout
              v-else-if="eventField === 'Ticket category' && attendee.organizationItemCategory"
              row
            >
              <v-icon
                :color="attendee.organizationItemCategory.color"
                size="1.8rem"
                style="padding-right: 0.5rem"
              >
                fiber_manual_record
              </v-icon>
              <span style="margin-top: 2px">{{ attendee.organizationItemCategory.name }}</span>
            </v-layout>
            <v-layout
              v-else-if="
                eventField === '' &&
                  ['sport-organization-subscriptions-list', 'sport-organization-members-list'].includes($router.currentRoute.name)
              "
              style="color: #0277bd"
              @click.stop="$emit('send-email', attendee.id)"
            >
              Send email
            </v-layout>
            <span v-else>
              <span v-if="eventField === 'Created At'">{{
                displayCreatedAt(attendee.createdAt)
              }}</span>
              <span v-if="eventField === 'Status' && attendee.status">
                {{ attendee.status }}
              </span>
              <span v-if="eventField === 'Broj mobitela' && attendee.fields[eventField]">
                {{ JSON.parse(attendee.fields[eventField]).numberPrefix }}
                {{ JSON.parse(attendee.fields[eventField]).number }}
              </span>
              <span
                v-if="
                  Object.keys(attendeeFields).length !== 0 &&
                    eventField !== 'Created At' &&
                    attendeeFields[eventField] &&
                    attendeeFields[eventField].type.toLowerCase() === 'country' &&
                    attendee.fields[eventField]
                "
                row
              >
                <img
                  style="margin-right: 6px"
                  width="20"
                  height="12"
                  :src="`${frontendURL}/assets/flags/${attendee.fields[
                    eventField
                  ].toLowerCase()}.svg`"
                >
                {{ attendee.fields[eventField] }}
              </span>
              <span v-else>
                <v-icon
                  v-if="
                    ['tickets', 'promo-codes'].includes($router.currentRoute.name) &&
                      ['discount'].includes(eventField.toLowerCase())
                  "
                  color="red"
                  size="13"
                  style="padding-right: 6px"
                >fiber_manual_record</v-icon>
                {{ displayAttendeeField(attendee, eventField) }}
              </span>
            </span>
          </div>
          <div
            v-if="['accreditations', 'curated-invitations'].includes($router.currentRoute.name)"
            :class="[
              'row_action_container',
              { row_action_container__hover: isHovering(attendee.id) },
              { row_action_container_mobile: isMobile },
            ]"
          >
            <div class="row_action_button" @click.stop="() => print(attendee.id)">
              <v-icon color="#0277bd">print</v-icon>
            </div>
            <div
              class="row_action_button"
              @click.stop="
                () => {
                  deleteDialogAttendee = attendee.id
                  isDialogOpen = true
                }
              "
            >
              <v-icon class="delete-icon">delete</v-icon>
            </div>
          </div>
          <div
            v-if="['tickets', 'promo-codes'].includes($router.currentRoute.name)"
            :class="[
              'row_action_container',
              { row_action_container__hover: isHovering(attendee.id) },
              { row_action_container_mobile: isMobile },
            ]"
          >
            <div
              class="row_action_button"
              @click.stop="
                () => {
                  $emit('orderDelete', attendee.id)
                }
              "
            >
              <v-icon class="delete-icon">delete</v-icon>
            </div>
          </div>
        </div>
      </div>
    </v-flex>
    <delete-dialog
      :content="`Are you sure you want to delete accreditation? This operation cannot be undone.`"
      :on-delete="() => deleteAttendee(deleteDialogAttendee, eventId)"
      :show.sync="isDialogOpen"
      title="Delete accreditation"
    />
  </v-layout>
</template>

<script>
import ColorToggleButton from '@/components/shared/inputs/color-toggle-button.vue'
import { ColorToggleTypes } from '@/types'
import moment from 'moment'
import { DELETE_ATTENDEE } from '@/graphql/accreditation.graphql'
import { frontendURL } from '@/utils'
import DeleteDialog from '../../shared/dialogs/delete-dialog'
import TableHeader from './header.vue'
import { sportOrganizationRouteNames } from '@/routing/routeNames/sportOrganizerRouteNames'

export default {
  name: 'table-list',
  components: {
    ColorToggleButton,
    TableHeader,
    DeleteDialog,
  },
  props: {
    attendees: {
      type: Array,
      default: () => [],
    },
    organizationSlug: String,
    eventId: String,
    visibleFields: {
      type: Array,
      default: () => [],
    },
    selected: Array,
    pagination: {
      type: Object,
      default: () => {},
    },
    attendeeFields: {
      type: Object,
      default: () => {},
    },
    bodyStyle: {
      type: String,
    },
    hideCheckbox: {
      type: Boolean,
      default: false,
    },
    showToggleButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hoveringRowId: undefined,
      allSelected: this.selected.length > 0 && this.selected.length === this.attendees.length,
      selectedCopy: this.mapSelectedToObject(this.selected),
      frontendURL: '',
      deleteDialogAttendee: null,
      isDialogOpen: false,
      isDesktop: false,
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
    }
  },
  computed: {
    headerItems() {
      return {
        fixed: this.visibleFields[0],
        scrollable: this.visibleFields.slice(1),
      }
    },
  },
  watch: {
    selected(val) {
      this.selectedCopy = this.mapSelectedToObject(val)
      if (val.length === 0) this.allSelected = false
      else if (val.length === this.attendees.length) this.allSelected = true
    },
  },
  methods: {
    displayCreatedAt(createdAt) {
      return moment(createdAt).format('MM/DD/YYYY HH:mm')
    },
    displayAttendeeField: function (attendee, eventField) {
      if (
        [
          'organization-promo-code-info',
          'organization-promo-codes',
          'tickets',
          'promo-codes',
          'organization-subscribers',
          'theater-organization-genres',
          'theater-tickets',
          'tickets-sport',
          'theater-organization-mailing-list',
          'theater-organization-tags',
          'theater-organization-ticket-type',
          'theater-organization-subscription-list',
          'theater-organization-subscription-plan',
          'theater-organization-memberships',
          'theater-organization-members-list',
          'theater-organization-promo-codes',
          'theater-organization-promo-code-info',
          'theater-accreditations',
          'ticket-categories',
          'sport-organization-subscriptions',
          'sport-organization-subscriptions-list',
          'sport-organization-promo-codes',
          'sport-organization-promo-code-info',
          'sport-organization-ticket-categories',
          'sport-organization-subscribers',
          'sport-organization-memberships',
          sportOrganizationRouteNames.sportOrganizationMembersList,
        ].includes(this.$router.currentRoute.name)
      ) {
        if (eventField.toLowerCase() === 'price') {
          return `${attendee[eventField.toLowerCase()]} ${attendee['currency']}`
        } else if (eventField.toLowerCase() === 'start date') {
          return attendee['from']
        } else if (eventField.toLowerCase() === 'member id no.') {
          return attendee['code']
        } else if (eventField.toLowerCase() === 'end date') {
          return attendee['to']
        } else if (eventField.toLowerCase() === 'expires') {
          return attendee['expires']
        } else if (eventField.toLowerCase() === 'subscription plan') {
          return attendee['Subscription plan']
        } else if (eventField.toLowerCase() === 'subscription status') {
          return attendee['Subscription status']
        } else if (eventField.toLowerCase() === 'duration') {
          return `${moment(attendee['from']).format('DD.MM.YYYY')} - ${moment(
            attendee['to'],
          ).format('DD.MM.YYYY')}`
        } else if (eventField.toLowerCase() === 'ticket') {
          return attendee['orderItem']['name']
        } else if (
          eventField.toLowerCase() === 'ticket name' ||
          eventField.toLowerCase() === 'plan'
        ) {
          return attendee['name']
        } else if (eventField.toLowerCase() === 'promo code') {
          return attendee['code']
        } else if (eventField.toLowerCase() === 'sales channel') {
          return attendee.ticketSellersLabel
        } else if (eventField.toLowerCase() === 'attendee') {
          return attendee['name']
        } else if (eventField.toLowerCase() === 'email') {
          return attendee['email']
        } else if (eventField.toLowerCase() === 'tickets type (no.)') {
          return attendee['ticketTypes']
        } else if (eventField.toLowerCase() === 'no. of tickets') {
          return attendee['ticketNumber']
        } else if (eventField.toLowerCase() === 'ticket category name') {
          return attendee['name']
        }

        return attendee[eventField.toLowerCase()]
      }

      if (!attendee.fields[eventField]) {
        return ''
      }

      return Array.isArray(attendee.fields[eventField])
        ? attendee.fields[eventField].join(', ')
        : attendee.fields[eventField]
    },
    isHovering(id) {
      return this.hoveringRowId === id
    },
    updateSelected(attendeeId, selected) {
      this.selectedCopy[attendeeId] = selected
      const selectedIds = this.mapSelectedIds()

      if (selectedIds.length === this.attendees.length) this.allSelected = true
      else if (this.allSelected) this.allSelected = false

      return this.$emit('update:selected', selectedIds)
    },
    updateToggleSwitch(attendeeId, value) {
      this.$emit('updateTicketActivity', attendeeId, value)
    },
    mapSelectedToObject(selectedIds) {
      return selectedIds.reduce((acc, s) => {
        acc[s] = true

        return acc
      }, {})
    },
    mapSelectedIds() {
      return Object.entries(this.selectedCopy)
        .map(([id, value]) => (value ? id : undefined))
        .filter(i => i)
    },
    handleSelectAll(allSelected) {
      if (!allSelected) return this.$emit('update:selected', [])
      const deletingTickets = this.attendees.some(a => a.hasOwnProperty('isSoldOut'))
      const tickets = this.attendees.filter(a => a.isSoldOut).map(a => a.id)
      const selectAll = this.attendees.map(a => a.id)

      return this.$emit('update:selected', deletingTickets ? tickets : selectAll)
    },
    async deleteAttendee(attendeeId, eventId) {
      await this.$apollo.mutate({
        mutation: DELETE_ATTENDEE,
        variables: { eventId, attendeeId },
      })
      this.$emit('attendeeDeleted')
    },
    async print(attendeeId) {
      const url = `${frontendURL}/organizations/${this.organizationSlug}/events/${this.eventId}/accreditation/${attendeeId}/edit/print`
      window.open(url, '_blank', 'noopener')
    },
    isTicketSoldOut(ticket) {
      return ticket.quantity <= 0
    },
    isOrderItemActive(attendee) {
      const currentDate = moment()

      return currentDate.isBetween(moment(attendee.fullDateFrom), moment(attendee.fullDateTo))
    },
    isTicketOnHold(ticket) {
      const currentDate = moment()

      return currentDate.isBefore(moment(ticket.fullDateFrom))
    },
    isTicketAvailable(ticket) {
      const currentDate = moment()

      return currentDate.isBetween(moment(ticket.fullDateFrom), moment(ticket.fullDateTo))
    },
    findToggleLabel(ticket) {
      if (this.isTicketSoldOut(ticket)) {
        return 'Sold Out'
      } else if (this.isTicketOnHold(ticket)) {
        return 'On Hold'
      } else if (!this.isTicketAvailable(ticket)) {
        return 'Closed'
      } else if (this.isTicketAvailable(ticket)) {
        return 'Available'
      }
    },
    findToggleType(ticket) {
      if (this.isTicketSoldOut(ticket)) {
        return ColorToggleTypes.DISABLED
      } else if (this.isTicketOnHold(ticket)) {
        return ColorToggleTypes.REGULAR
      } else if (this.isTicketAvailable(ticket)) {
        return ColorToggleTypes.SUCCESSFUL
      } else {
        return ColorToggleTypes.FAILED
      }
    },
    findBackgroundHoverColor(ticket) {
      if (this.$router.currentRoute.name !== 'tickets') {
        return '#F0F6FA'
      }

      if (this.isTicketAvailable(ticket)) {
        return '#EEF6EF'
      } else {
        return '#F0F6FA'
      }
    },
  },
}
</script>

<style scoped>
@media (min-width: 800px) {
  .wrapper_scrollable {
    overflow: auto;
  }
}

@media (max-width: 800px) {
  .overflow-wrapper {
    overflow: auto;
  }
}

.wrapper {
  font-size: 16px;
}

.wrapper_scrollable {
  width: 0;
}

.wrapper_scrollable::-webkit-scrollbar {
  -webkit-appearance: none;
}

.wrapper_scrollable::-webkit-scrollbar:horizontal {
  height: 11px;
}

.wrapper_scrollable::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 2px solid white;
  background-color: rgba(0, 0, 0, 0.2);
}

.table_grid {
  cursor: pointer;
  display: grid;
  grid-auto-flow: column;
  height: 55px;
  /* float: left; */
}

.table_grid_fixed {
  cursor: pointer;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 50px minmax(200px, 150px);
  height: 55px;
}

.list_element {
  padding: 14px 12px;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* .list_element::-webkit-scrollbar {
    -webkit-appearance: none;
} */
::-webkit-scrollbar {
  height: 0px;
}

/* .list_element::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background-color: rgba(0, 0, 0, .2);
} */

.list_element__text {
  font-family: 'Source Sans Pro';
  font-size: 16px;
  color: #333333;
}

.border__left {
  border-left: 2px solid #f5f5f5;
}

.border__right {
  border-right: 2px solid #f5f5f5;
}

.border__bottom {
  border-bottom: 2px solid #f5f5f5;
}

.action_checkbox {
  margin: 0;
  height: 40px;
  width: 0px;
  padding-left: 12px;
  text-align: center;
}

.action_checkbox_fixed {
  margin: 0;
  height: 50px;
  padding-left: 12px;
  text-align: center;
}

.row_action_container {
  display: flex;
  width: fit-content;
  flex-direction: row;
  padding: 12px 16px 12px 0;
  opacity: 0;
  position: absolute;
  right: 20px;
}

/*.row_action_container:hover {
  opacity: 1;
}*/

.row_action_button {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  overflow: hidden;
}

.row_action_button:hover {
  background: rgba(2, 119, 189, 0.2);
}

.delete-icon {
  color: #db384c;
  background-color: #fbebed;
}

.delete-icon:hover {
  color: #bd2a3c;
}

.row_action_container__hover,
.row_action_container_mobile {
  opacity: 1;
}

/*
  FADE EFFECT, commented out for now because it caused too many issues

 .fade_container {
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
  position: relative;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
/*
.fade_left::after {
  animation: fadeIn 0.35s;
  content: "";
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  bottom: 10px;
  height: 40px;
  pointer-events: none;
  background-image: linear-gradient(to left, rgba(255, 255, 255, 0), #f5f5f5 100%);
  width: 3%;
}


.fade_left::before {
  animation: fadeIn 0.35s;
  content: "";
  position: absolute;
  z-index: 1;
  top: 42px;
  left: 0;
  bottom: 15px;
  pointer-events: none;
  background-image: linear-gradient(to left, rgba(255, 255, 255, 0), white 100%);
  width: 3%; */
</style>
